export var subscribers = [];
//# sourceMappingURL=messagingContainer.js.map